import ReactPlayer from "react-player/lazy";

import { ArticleDetail } from "@sellernote/shared/src/api/dto/entities/common/support";
import { ShipdaCurrentLanguage } from "@sellernote/shared/src/i18n/i18nForShipda";

import Styled from "./index.styles";

export default function BoardContent({
  title,
  annotation,
  desc,
  videoURL,
  translatedBy,
  className,
}: {
  title: string;
  annotation?: string;
  desc: string;
  videoURL: string | undefined;
  translatedBy: ArticleDetail["translatedBy"];
  className?: string;
}) {
  const isEn = ShipdaCurrentLanguage.currentLanguage === "en";

  const isAITranslated = translatedBy === "AI";

  return (
    <Styled.container
      className={`${className ? className : ""} board-contents`}
    >
      <h3>{title}</h3>

      {isEn && isAITranslated && (
        <Styled.aiTranslationBanner>
          ✏️️ This content is AI-translated; certain sentences might not fully
          align with the original meaning.
        </Styled.aiTranslationBanner>
      )}

      {annotation && (
        <div className="annotation">
          <strong>{annotation}</strong>
        </div>
      )}

      <div
        className="desc"
        dangerouslySetInnerHTML={{
          __html: desc,
        }}
      />

      {videoURL && (
        <div className="video">
          <ReactPlayer
            className="react-player"
            url={videoURL}
            width="100%"
            height="100%"
          />
        </div>
      )}
    </Styled.container>
  );
}
